import type { ReactNode } from "react"
import { Marca } from "./Marca"
import { Navegacao } from "./Navegacao"

interface Props {
    titulo: string
    children: ReactNode
    acao?: { rotulo: string; onClick: () => void }
    // O rodapé some só na tela de "abra pelo e-mail", onde mandar responder o e-mail seria
    // circular: a pessoa está aqui justamente porque não tem o e-mail à mão.
    ocultarSuporte?: boolean
    // Só nos avisos em que o acesso vale: com o link vencido, a outra tela falharia do mesmo jeito.
    comNavegacao?: boolean
}

// Toda falha vira esta tela. Mesma moldura da página cheia — marca em cima, cartão no meio, largura
// de leitura — para o RH não ter a sensação de ter caído fora do site.
export const Aviso = ({ titulo, children, acao, ocultarSuporte, comNavegacao }: Props) => (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col justify-center px-5 py-16">
        <Marca />
        {comNavegacao && <Navegacao />}
        <div className="rounded-xl border border-line bg-card p-8 shadow-sm">
            <h1 className="font-display text-xl font-black">{titulo}</h1>
            <div className="mt-3 space-y-3 text-soft [&_b]:text-ink">{children}</div>

            {acao && (
                <button
                    type="button"
                    onClick={acao.onClick}
                    className="mt-6 rounded-full bg-brand px-6 py-3 font-display font-semibold text-brand-ink transition-colors hover:bg-brand-strong"
                >
                    {acao.rotulo}
                </button>
            )}
        </div>

        {!ocultarSuporte && (
            // Responder o e-mail, e não um endereço novo: a conversa já existe, chega em quem
            // acompanha aquele empregador, e é um dado a menos para o RH guardar.
            <p className="mt-6 text-center text-xs text-faint">
                Se continuar assim, responda o e-mail que trouxe você até aqui — a gente resolve por
                lá.
            </p>
        )}
    </main>
)
